import { useEffect, useState } from 'react'
import axios from 'axios'

import { useAppSelector, useAppDispatch } from '../../store/hooks'
import { addList, resetAll, selectList, selectFiltred, selectIsSearchActive } from '../../store/reducer/model'
import { selectBrandTheme } from '../../store/reducer/ui'
import constant from '../../src/utils/constant'

interface Checked {
    label: string
    checked: boolean
}

export default function useInitHomePage(
    checkedModes: Array<Checked>,
    checkedTypes: Array<Checked>,
    checkedRefrigerants: Array<Checked>
) {
    const dispatch = useAppDispatch()
    const modelList = useAppSelector((state) => selectList(state.model))
    const company = useAppSelector((state) => selectBrandTheme(state.ui))
    const modelListFiltered = useAppSelector((state) => selectFiltred(state.model))
    const isSearchActive = useAppSelector((state) => selectIsSearchActive(state.model))
    const [rowsPerPage, setRowsPerPage] = useState(12)
    const [totalRows, setTotalRows] = useState(0)
    const [page, setPage] = useState(1)
    const [isLoadingModels, setIsLoadingModels] = useState(false)

    useEffect(() => {
        if (isSearchActive) {
            setPage(1)
        }
    }, [isSearchActive])
    useEffect(() => {
        if (checkedRefrigerants.length === 0 && checkedTypes.length === 0 && checkedModes.length === 0) return
        const controller = new AbortController()
        setIsLoadingModels(true)
        axios
            .get(constant.backend.SEARCH_ALL_MODEL + `/${rowsPerPage}/${page}`, {
                params: {
                    company,
                    types: checkedTypes
                        .filter((t) => t.checked)
                        .map((t) => t.label)
                        .join(','),
                    modes: checkedModes
                        .filter((m) => m.checked)
                        .map((m) => m.label)
                        .join(','),
                    refrigerants: checkedRefrigerants
                        .filter((r) => r.checked)
                        .map((r) => r.label)
                        .join(','),
                },
                signal: controller.signal,
            })
            .then(({ data }) => {
                setTotalRows(data.totalResult)
                dispatch(addList(data.result))
                setIsLoadingModels(false)
            })
            .catch((err) => {
                if (err.name === 'CanceledError') return
                console.error(err)
                setIsLoadingModels(false)
            })

        return () => {
            controller.abort()
            dispatch(resetAll())
        }
    }, [page, checkedModes, checkedTypes, checkedRefrigerants])

    const handleChangePage = (_: unknown, newPage: number) => {
        setPage(newPage)
    }
    return {
        modelList,
        modelListFiltered,
        handleChangePage,
        page,
        setPage,
        rowsPerPage,
        totalRows,
        isLoadingModels,
        setIsLoadingModels,
    }
}
